export default __webpack_public_path__ + "static/media/react-logo.080dc81e.png";